// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1d_26","image":"Header_image__2i0Hn","name":"Header_name__1iR3H","info":"Header_info__3fbFf","infoRow":"Header_infoRow__36L2J"};